import { createContext, useContext, useEffect, useState, ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
type Locale = 'fr' | 'en'
const Context = createContext({ locale: 'fr' as Locale, t: (fr: string, _en: string) => fr, switchLanguage: () => {}, url: (path: string) => path })
export function LocaleProvider({ children }: { children: ReactNode }) {
  const location = useLocation(), navigate = useNavigate()
  const [locale, setLocale] = useState<Locale>(() => {
    const value = new URLSearchParams(window.location.search).get('lang') || localStorage.getItem('salmaload-language')
    return value === 'en' ? 'en' : 'fr'
  })
  useEffect(() => {
    const value = new URLSearchParams(location.search).get('lang')
    if (value === 'fr' || value === 'en') setLocale(value)
  }, [location.search])
  useEffect(() => { document.documentElement.lang = locale; document.title = 'SalmaLoad'; localStorage.setItem('salmaload-language', locale) }, [locale])
  const url = (path: string) => { const value = new URL(path, window.location.origin); value.searchParams.set('lang', locale); return value.pathname + value.search + value.hash }
  const switchLanguage = () => { const next = locale === 'fr' ? 'en' : 'fr'; setLocale(next); const params = new URLSearchParams(location.search); params.set('lang', next); navigate(location.pathname + '?' + params + location.hash, { replace: true }) }
  return <Context.Provider value={{ locale, t: (fr, en) => locale === 'fr' ? fr : en, switchLanguage, url }}>{children}</Context.Provider>
}
export const useLocale = () => useContext(Context)
